import { pushga } from '@stencil/ga-utils';

const pushGAEvents = (
  event,
  eventName,
  eOption,
  eventCategory = '',
  eventAction = '',
  eventLabel = '',
  cdFields = {}
) => {
  const query = new window.URLSearchParams(window.location.search);
  // const expN = query.get('en') || '';
  // const expV = query.get('ev') || '';
  pushga({
    event,
    eventName,
    selectedEventOption: eOption,
    eventCategory,
    eventAction,
    eventLabel,
    userEmail: window?.userInfo?.email || '',
    // ...(expN ? { exp_name: expN } : null),
    // ...(expV ? { exp_variant_id: expV } : null),
    ...cdFields
  });
};

export default pushGAEvents;
